window.onload = () => {
  setStickyTop();
}

function setStickyTop () {
  const header_height = document.querySelector('.section-header').clientHeight,
        sticky_el = document.querySelector('.c-col__menu-wrapper'),
        scroll_top = header_height + sticky_el.clientHeight;

  sticky_el.style.top = header_height + 'px';

  
  const anchorLinks = document.querySelectorAll('.c-col__anchor');
    
  for (let i = 0; i < anchorLinks.length; i++) {
    const link = anchorLinks[i];
    link.addEventListener('click', e => {
      e.preventDefault();

      // document.querySelectorAll('.header__active-menu-item').forEach(el=>el.classList.remove('header__active-menu-item'));
      // link.querySelector('span').classList.add('header__active-menu-item');
  
      const targetElement = document.querySelector(link.getAttribute('href')) || document.querySelector(anchorLinks[i+1].getAttribute('href'));

      window.scrollTo({
        top: targetElement.offsetTop - scroll_top,
        behavior: 'smooth'
      });
    });
  }


  const observedElements = document.querySelectorAll('.single-wine-collection');
  
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // document.querySelectorAll('.header__active-menu-item').forEach(el=>el.classList.remove('header__active-menu-item'));
        anchorLinks[[...observedElements].indexOf(entry.target) + 1].querySelector('span').classList.add('header__active-menu-item')
      } else {
        anchorLinks[[...observedElements].indexOf(entry.target) + 1].querySelector('span').classList.remove('header__active-menu-item')
      }
    });
  }, { rootMargin: "-200px" });
  
  observedElements.forEach(element => {
    observer.observe(element);
  });

}